export default {
  present: {
    id: 'dateRange.present',
    defaultMessage: 'present',
  },
  from: {
    id: 'dateRange.from',
    defaultMessage: 'From',
  },
  until: {
    id: 'dateRange.until',
    defaultMessage: 'Until',
  },
  month: {
    id: 'dateRange.month',
    defaultMessage: `{month, select,
      1 {January}
      2 {February}
      3 {March}
      4 {April}
      5 {May}
      6 {June}
      7 {July}
      8 {August}
      9 {September}
      10 {October}
      11 {November}
      12 {December}
      other {}
    }`,
  },
};
